import React from 'react'

//imagenes
import "@hassanmojab/react-modern-calendar-datepicker/lib/DatePicker.css";
import { Outlet } from 'react-router-dom';

const Administracion = () => {
	return (
		<>
			<Outlet />
		</>
	)
}

export default Administracion